export default __webpack_public_path__ + "static/media/Y.ea19bacb.png";